'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var IconButton = require('@material-ui/core/IconButton');
var useTextEditor = require('./useTextEditor.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);

var ActionButton = _ref => {
  var {
    isActive,
    icon: IconComponent,
    label,
    onMouseDown
  } = _ref;
  var {
    classes
  } = useTextEditor.useTextEditor();
  return /*#__PURE__*/React__namespace.createElement(IconButton__default['default'], {
    className: classes.actionButton,
    color: isActive ? 'primary' : 'default',
    "aria-label": label,
    onMouseDown: onMouseDown
  }, /*#__PURE__*/React__namespace.createElement(IconComponent, {
    className: classes.actionButtonIcon
  }));
};
ActionButton.propTypes = {
  isActive: index.bool,
  icon: index.elementType,
  label: index.string,

  /**
   * Action callback when the button is pressed.
   * `onMouseDown` is used so that focus isn't stolen from the editor on the
   * click event.
   */
  onMouseDown: index.func
};

exports.ActionButton = ActionButton;
